import API from "../API";

var Share = {
    async CreateShareRequest(Request) {
        var result = await API.process(
            `api/Share/Request`,
            'POST',
            Request
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async UpdateConsent(RequestID, status) {
        var result = await API.process(
            `api/Share/Request/${RequestID}?status=${status}`,
            'PUT',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListShareRequests() {
        var result = await API.process(
            `api/Share/Requests`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ListShareRequestsShared() {
        var result = await API.process(
            `api/Share/Requests/shared`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
    async ValidateRequest(RequestID) {
        var result = await API.process(
            `api/Share/Request/${RequestID}/Verify`,
            'GET',
            null
        ).catch((err) => {
            throw err;
        })

        return result
    },
}
export default Share;